import React from "react";

export default function DownloadComplete({ color = "#FFF", ...restProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={101}
      height={21}
      viewBox="0 0 101 21"
      {...restProps}
    >
      <g fill={color} fillRule="evenodd">
        <text fontSize="15.54" fontWeight="bold" letterSpacing="-.25">
          <tspan x="25.53" y={15}>
            Completed
          </tspan>
        </text>
        <path d="M20.024 2.15a.854.854 0 0 0-1.234 0l-9.087 9.087-2.91-2.911a.854.854 0 0 0-1.235 0 .852.852 0 0 0 0 1.235l3.528 3.53a.95.95 0 0 0 .617.263c.177 0 .441-.087.619-.264l9.702-9.703a.853.853 0 0 0 0-1.237" />
        <path d="M17.996 7.532c-.44.089-.707.617-.618 1.058.177.707.265 1.412.265 2.118a7.906 7.906 0 0 1-7.94 7.939 7.905 7.905 0 0 1-7.938-7.94c0-4.41 3.528-7.94 7.938-7.94 1.5 0 2.912.443 4.146 1.148.442.265.97.09 1.236-.264.264-.441.087-.97-.265-1.236-1.588-.882-3.352-1.41-5.117-1.41A9.675 9.675 0 0 0 0 10.707a9.675 9.675 0 0 0 9.703 9.703 9.676 9.676 0 0 0 9.704-9.703c0-.883-.088-1.765-.353-2.56-.088-.44-.618-.704-1.058-.616" />
      </g>
    </svg>
  );
}
